import axios from "axios";

const AxiosInstance = axios.create({
  baseURL: "http://192.168.1.20:5000/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default AxiosInstance;
